module.exports = __webpack_public_path__ + "static/media/0_thefool.0b25bd0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/0_thefool.png
// module id = 63
// module chunks = 0